export default __webpack_public_path__ + "static/media/ybx_logo_dark_tn.dff743f9.svg";